"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getKeyFromState(state) {
    const { contentId, userId } = state;
    return `${userId}_${contentId}`;
}
exports.getKeyFromState = getKeyFromState;
function getKeyFromContentAndUser(user, content) {
    const { userId } = user;
    const { _id: contentId } = content;
    return `${userId}_${contentId}`;
}
exports.getKeyFromContentAndUser = getKeyFromContentAndUser;
function getKeyFromContentIdAndUser(user, contentId) {
    const { userId } = user;
    return `${userId}_${contentId}`;
}
exports.getKeyFromContentIdAndUser = getKeyFromContentIdAndUser;
//# sourceMappingURL=getKeyFromState.js.map